import { Edit, ShowButton, TopToolbar } from "react-admin";

import BackButtonToolbar from "features/BackButtonToolbar";
import SaveForm from "./Partials/SaveForm";
import { useState } from "react";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";

const EditErasmusIncomingTeachers = () => {
  const [cvId, setCVId] = useState(null);
  const [mobilityAgreementId, setMobilityAgreementId] = useState(null);
  const [acceptanceLetterId, setAcceptanceLetterId] = useState(null);
  const dataAll = (obj, keysToRemove = []) => {
    return Object.fromEntries(Object.entries(obj).filter(([key]) => !keysToRemove.includes(key)));
  };

  const handleSend = data => ({
    ...dataAll(data, ["cvId", "mobilityAgreementId", "acceptanceLetterId"]),
    cvId: cvId ?? data.cvId,
    mobilityAgreementId: mobilityAgreementId ?? data.mobilityAgreementId,
    acceptanceLetterId: acceptanceLetterId ?? data.acceptanceLetterId,
  });
  return (
    <Edit
      transform={handleSend}
      title="Редактирай пристигащ преподавател за обучение"
      actions={
        <BackButtonToolbar
          additionalButton={
            <SecuredComponent permission={permissions.canPreviewErasmusIncomingTeachers}>
              <ShowButton
                variant="contained"
                size="medium"
              />
            </SecuredComponent>
          }
        />
      }
    >
      <SaveForm
        setCVId={setCVId}
        setMobilityAgreementId={setMobilityAgreementId}
        setAcceptanceLetterId={setAcceptanceLetterId}
      />
    </Edit>
  );
};
export default EditErasmusIncomingTeachers;
